import { useEffect, useState } from 'react';
import getIn from 'immutable-less/transmute/getIn';
import { useQuery, useMutation } from 'data-fetching-client';
import { CANCEL_LIST_PREVIEW, CREATE_LIST_PREVIEW, FETCH_COMPLETED_LIST_PREVIEW, FETCH_LIST_PREVIEW_STATUS } from 'automation-ui-enrollment/queries/listPreviewQueries';
const POLLING_FREQUENCY_MS = 5000;
const useKickoffContactListPreview = ({
  filterBranch,
  objectTypeId,
  onCompleted,
  onError
}) => {
  const [createListPreview] = useMutation(CREATE_LIST_PREVIEW, {
    onCompleted,
    onError
  });
  useEffect(() => {
    createListPreview({
      variables: {
        filterBranch,
        objectTypeId
      }
    }).catch(() => {});
  }, [filterBranch, objectTypeId, createListPreview]);
};
const usePollForContactListPreviewResult = ({
  onCompleted,
  onError,
  previewId,
  skip
}) => {
  // polling logic
  const {
    data: listStatusData,
    startPolling,
    stopPolling
  } = useQuery(FETCH_LIST_PREVIEW_STATUS, {
    // @ts-expect-error FIXME: update code for `TypedDocumentNode` changes
    variables: {
      previewId
    },
    skip
  });
  useEffect(() => {
    if (!skip) {
      startPolling(POLLING_FREQUENCY_MS);
    } else {
      stopPolling();
    }
  }, [previewId, skip, startPolling, stopPolling]);

  // handle status response
  useEffect(() => {
    if (listStatusData) {
      const response = listStatusData.fetchContactListPreviewStatus;
      if (response === 'COMPLETE') {
        onCompleted();
      } else if (response === 'SERVER_ERROR') {
        onError();
      }
    }
  }, [listStatusData, onCompleted, onError]);
};

// move `previewId` outside of hook so that the value isn't erased during unmounting logic
let backupPreviewId = null;
const useILSListSizeEstimate = (filterBranch, objectTypeId) => {
  const [cancel, setCancel] = useState(false);
  const [isPreviewCreated, setIsPreviewCreated] = useState(false);
  const [previewId, setPreviewId] = useState(null);
  const [error, setError] = useState(false);
  const handleError = () => {
    if (!cancel) {
      setError(true);
    }
  };

  // if filterBranch changes, reset all state so that the polling process restarts
  useEffect(() => {
    setCancel(false);
    setIsPreviewCreated(false);
    setPreviewId(null);
    setError(false);
  }, [filterBranch]);
  useKickoffContactListPreview({
    filterBranch,
    objectTypeId,
    onCompleted: response => {
      if (response && !cancel) {
        const resultPreviewId = response.createContactListPreview.previewId;
        setPreviewId(resultPreviewId);
        backupPreviewId = resultPreviewId;
      }
    },
    onError: handleError
  });
  usePollForContactListPreviewResult({
    onCompleted: () => {
      if (!cancel) {
        setIsPreviewCreated(true);
      }
    },
    onError: handleError,
    previewId,
    skip: !previewId || error || isPreviewCreated
  });
  const {
    data
  } = useQuery(FETCH_COMPLETED_LIST_PREVIEW, {
    // @ts-expect-error FIXME: update code for `TypedDocumentNode` changes
    variables: {
      previewId
    },
    skip: !isPreviewCreated || cancel
  });
  const estimate = getIn(['fetchCompletedContactListPreview', 'results', 'estimatedCount'], data);
  const [cancelContactListPreview] = useMutation(CANCEL_LIST_PREVIEW);
  const handleCancel = () => {
    if (backupPreviewId) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      cancelContactListPreview({
        variables: {
          previewId: backupPreviewId
        }
      });
    }
    if (setCancel) {
      setCancel(true);
    }
  };
  return {
    estimate,
    loading: !error && estimate === undefined && !cancel,
    error,
    onCancel: handleCancel
  };
};
export default useILSListSizeEstimate;